import AbstractTokenStrategy from './abstractTokenStrategy';

class KlickauthTokenStrategy extends AbstractTokenStrategy {
  constructor() {
    super('klicksend-auth-token');
  }
}

export default KlickauthTokenStrategy;
